var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "ring-icon-star-filled",
  "use": "ring-icon-star-filled-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"ring-icon-star-filled\"><path d=\"M9.976 8.325L14 5H9L7 0 5 5H0l4.024 3.304-1.371 5.018 4.305-2.871 4.36 2.871-1.342-4.997z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id